import script from "./form2.vue?vue&type=script&setup=true&lang=js"
export * from "./form2.vue?vue&type=script&setup=true&lang=js"

import "./form2.vue?vue&type=style&index=0&id=bed1e5b4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed1e5b4"]])

export default __exports__